import WordTable from './WordTable';

export default WordTable;